<template>
  <div>
    <div class="topbar"><div class="container"><span v-html="html(homeTopoContato, 'iti_nome')"></span><span><span v-html="html(homeTopoContato, 'iti_referencia')"></span> · <a :href="phoneLink"><span v-html="html(homeTopoContato, 'iti_campoextra1')"></span></a> · <a :href="link(homeTopoContato, 'iti_link_btn1', 'https://wa.me/5551991544590')"><span v-html="html(homeTopoContato, 'iti_campoextra2')"></span> <span v-html="html(homeTopoContato, 'iti_campoextra3')"></span></a></span></div></div>
    <header class="header">
      <nav class="nav container" aria-label="Navegação principal">
        <router-link to="/" class="brand" aria-label="Imaginar — página inicial"><img class="brand-logo" src="/site-assets/layouts/imaginarvet-2008/assets/images/logo-imaginar.png" alt="Imaginar — Diagnóstico Veterinário"></router-link>
        <div class="navlinks" id="main-menu" :class="{ open: menuOpen }" @click="closeMenu"><router-link to="/">Home</router-link><router-link to="/quem-somos">Quem somos</router-link><router-link to="/exames">Exames</router-link><router-link to="/eventos">Eventos</router-link><router-link to="/blog">Blog</router-link><router-link to="/galeria">Galeria Pets</router-link><router-link to="/contato">Contato</router-link></div>
        <a class="btn btn-primary" :href="link(homeTopoContato, 'iti_link_btn1')">Agendar exame</a>
        <button class="menu-toggle" :aria-expanded="menuOpen ? 'true' : 'false'" aria-controls="main-menu" :aria-label="menuOpen ? 'Fechar menu' : 'Abrir menu'" @click="menuOpen = !menuOpen">☰</button>
      </nav>
    </header>
  </div>
</template>

<script>
import { contentValue, loadScreens, normalizeInternalLink } from '@/services/contentApi';
export default {
  name: 'PageHeader',
  data() { return { homeTopoContato: {}, menuOpen: false }; },
  computed: {
    phoneLink() {
      const phone = String(contentValue(this.homeTopoContato, 'iti_campoextra1', '')).replace(/<[^>]*>/g, '').replace(/\D/g, '');
      return phone ? 'tel:' + phone : '#';
    },
  },
  created() { this.loadHeader(); },
  methods: {
    html(source, field, fallback = '') { return contentValue(source, field, fallback); },
    link(source, field, fallback = '') { return normalizeInternalLink(contentValue(source, field, fallback), fallback); },
    closeMenu() { this.menuOpen = false; },
    async loadHeader() { Object.assign(this, await loadScreens([{ ctiId: 1, key: 'homeTopoContato', multi: false }])); },
  },
};
</script>
